"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuidService = void 0;
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
var hexlist = '0123456789abcdef';
var b64list = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
var GuidService = /** @class */ (function () {
    function GuidService() {
    }
    GuidService.prototype.generate = function () {
        var d = new Date().getTime(); // Timestamp
        var d2 = (performance && performance.now && performance.now() * 1000) || 0; // Time in microseconds since page-load or 0 if unsupported
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16; // random number between 0 and 16
            if (d > 0) {
                // Use timestamp until depleted
                // tslint:disable-next-line:no-bitwise
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            }
            else {
                // tslint:disable-next-line:no-bitwise
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            // tslint:disable-next-line:no-bitwise
            return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
    };
    GuidService.prototype.base64ToGuid = function (base64) {
        var hex = '';
        for (var i = 0; i < 24;) {
            var e1 = b64list.indexOf(base64[i++]);
            var e2 = b64list.indexOf(base64[i++]);
            var e3 = b64list.indexOf(base64[i++]);
            var e4 = b64list.indexOf(base64[i++]);
            var c1 = (e1 << 2) | (e2 >> 4);
            var c2 = ((e2 & 15) << 4) | (e3 >> 2);
            var c3 = ((e3 & 3) << 6) | e4;
            hex += hexlist[c1 >> 4];
            hex += hexlist[c1 & 15];
            if (e3 !== 64) {
                hex += hexlist[c2 >> 4];
                hex += hexlist[c2 & 15];
            }
            if (e4 !== 64) {
                hex += hexlist[c3 >> 4];
                hex += hexlist[c3 & 15];
            }
        }
        var a = substr(hex, 6, 2) + substr(hex, 4, 2) + substr(hex, 2, 2) + substr(hex, 0, 2);
        var b = substr(hex, 10, 2) + substr(hex, 8, 2);
        var c = substr(hex, 14, 2) + substr(hex, 12, 2);
        var d = substr(hex, 16, 16);
        hex = a + b + c + d;
        var uuid = substr(hex, 0, 8) +
            '-' +
            substr(hex, 8, 4) +
            '-' +
            substr(hex, 12, 4) +
            '-' +
            substr(hex, 16, 4) +
            '-' +
            substr(hex, 20, 12);
        return uuid;
    };
    // GUID string with four dashes is always MSB first,
    // but base-64 GUID's vary by target-system endian-ness.
    // Little-endian systems are far more common.  Set le==true
    // when target system is little-endian (e.g., x86 machine).
    GuidService.prototype.guidToBase64 = function (g) {
        var s = g.replace(/[^\da-f]/gi, '').toLowerCase();
        if (s.length !== 32)
            return '';
        s =
            s.slice(6, 8) +
                s.slice(4, 6) +
                s.slice(2, 4) +
                s.slice(0, 2) +
                s.slice(10, 12) +
                s.slice(8, 10) +
                s.slice(14, 16) +
                s.slice(12, 14) +
                s.slice(16);
        s += '0';
        var a;
        var p;
        var q;
        var r = '';
        var i = 0;
        while (i < 33) {
            a =
                (hexlist.indexOf(s.charAt(i++)) << 8) |
                    (hexlist.indexOf(s.charAt(i++)) << 4) |
                    hexlist.indexOf(s.charAt(i++));
            p = a >> 6;
            q = a & 63;
            r += b64list.charAt(p) + b64list.charAt(q);
        }
        r += '==';
        return r;
    };
    GuidService.prototype.convertToGuid = function (guid) {
        if (guid === '1')
            return '5mVJsLupH1mPihrcssjcOQ';
        var encoded = this.guidToBase64(guid);
        encoded = encoded.replace(/\//g, '_').replace(/\+/g, '-');
        return encoded.slice(0, 22);
    };
    GuidService.prototype.convertToLongGuid = function (shortGuid) {
        var encoded = shortGuid.replace(/_/g, '/').replace(/-/g, '+');
        encoded = encoded + '==';
        var decoded = this.base64ToGuid(encoded);
        return decoded;
    };
    GuidService = __decorate([
        CommonService_decorator_1.CommonService('GuidService')
    ], GuidService);
    return GuidService;
}());
exports.GuidService = GuidService;
function substr(s, start, length) {
    return s.slice(start, start + length);
}
//# sourceMappingURL=Guid.service.js.map